/* eslint-disable */
import React, { useEffect } from "react";
import { Box } from "@material-ui/core";
import { httpPost } from "../../../../../Utils/apis/apis";
import { makeStyles } from "@material-ui/core/styles";
import LoaderSkeleton from "../LoaderSkeleton";
import { message } from "../../../../../Utils/config/messages";
import { getSubDomain } from "../../../Pages/Common/User Management/HelperFunctions";
const useStyles = makeStyles(() => ({
  noData: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  message: {
    textAlign: "center",
  },
  centerAligned: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default function M_PDFReader(props) {
  const classes = useStyles();
  const [pdfFileData, setPdfFileData] = React.useState();
  const [isLoading, setIsLoading] = React.useState(true);
  const [havingPDF, setHavingPDF] = React.useState(false);

  useEffect(() => {
    getPDF();
  }, [props.pdf]);

  const getPDF = async () => {
    if (!props.pdf) {
      setIsLoading(false);
      return;
    }
    if (props.directlink) {
      setPdfFileData(props.pdf);
      setIsLoading(false);
      setHavingPDF(true);
      return;
    }
    setIsLoading(true);
    let filepath = props.pdf;
    const url = `${process.env.DOCUMENT_HELPER}`;
    //important
    // new URL(window.location.href).hostname.split(".")[0]
    const subdomain = getSubDomain();
    // TODO - This header is common for all download/upload operation, we can switch to common function with some param
    let header = {
      filename: filepath,
      type: props.container,
      "file-operation": "download",
      "process-file": "yes",
      "x-functions-key": process.env.DOCUMENT_HELPER_KEY,
      subdomain: subdomain,
    };
    const formData = {};
    let response = await httpPost(url, formData, {
      responseType: "blob",
      headers: header,
    });
    if (response.size) {
      let blobData = window.URL.createObjectURL(
        new Blob([response], { type: "application/pdf" })
      );
      if (pdfFileData) {
        setPdfFileData("");
      }
      setPdfFileData(blobData);
      setIsLoading(false);
      setHavingPDF(true);
    } else {
      setIsLoading(false);
      setHavingPDF(false);
    }
  };

  return (
    <div>
      <>
        {isLoading ? (
          <>
            <LoaderSkeleton />
          </>
        ) : havingPDF ? (
          <Box
            style={{ backgroundColor: "var(--color-background-default)" }}
            width={"100%"}
            height={"60vh"}
          >
            {pdfFileData ? (
              <iframe
                src={`${pdfBlobUrl}#toolbar=0`}
                title="PDF Preview"
                style={{ width: "100%", height: "100%", border: "none" }}
              />
            ) : (
              ""
            )}
          </Box>
        ) : props.showDefaultMessage ? (
          <p className={classes.message}>{message.NO_CONTENT}</p>
        ) : (
          ""
        )}
      </>
    </div>
  );
}
